import React from "react"

interface Props<T> {
  updateAtom: (value: T) => void
  value: T
}

export function usePropagateValueToAtom<T>({ updateAtom, value }: Props<T>) {
  React.useEffect(() => {
    updateAtom(value)
  }, [updateAtom, value])
}
